import { SVGProps } from 'react';

export const Audits = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 0H0.875C0.392 0 0 0.392 0 0.875V16.625C0 17.108 0.392 17.5 0.875 17.5H3.5V0Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.25 6.125H7V3.5H12.25V6.125ZM13.125 0H5.25V17.5H13.125C13.608 17.5 14 17.108 14 16.625V0.875C14 0.392 13.608 0 13.125 0Z"
      fill="currentColor"
    />
  </svg>
);
